import React, { useState } from 'react';
import { X, Truck, Building2, Phone, Mail, FileText, User, CreditCard, Landmark, History, CircleDollarSign } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import HistoryDialog from '../HistoryDialog/HistoryDialog';
import '../AddFournisseurDialog/AddFournisseurDialog.css';

const ViewFournisseurDialog = ({ isOpen, onClose, fournisseur }) => {
  const { t } = useTranslation();
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  if (!isOpen || !fournisseur) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay ui-dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-container ui-dialog-container">
        <div className="dialog-header ui-dialog-header">
          <div className="dialog-title ui-dialog-title">
            <Truck size={24} />
            <h2>{t('fournisseurs.viewDialog.title')}</h2>
          </div>
          <button className="dialog-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="dialog-form">
          <div className="form-group">
            <label className="ui-label">
              <Building2 size={16} />
              {t('fournisseurs.dialog.form.name')}
            </label>
            <input type="text" value={fournisseur.name || '-'} readOnly className="ui-input" />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="ui-label">
                <User size={16} />
                {t('fournisseurs.dialog.form.contactName')}
              </label>
              <input type="text" value={fournisseur.contact_name || '-'} readOnly className="ui-input" />
            </div>
            <div className="form-group">
              <label className="ui-label">
                <FileText size={16} />
                {t('fournisseurs.dialog.form.nif')}
              </label>
              <input type="text" value={fournisseur.nif || '-'} readOnly className="ui-input" />
            </div>
          </div>

          <div className="form-group">
            <label className="ui-label">
              <FileText size={16} />
              {t('fournisseurs.dialog.form.address')}
            </label>
            <textarea value={fournisseur.address || '-'} readOnly rows={2} className="ui-textarea" />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="ui-label">
                <Mail size={16} />
                {t('fournisseurs.dialog.form.email')}
              </label>
              <input type="text" value={fournisseur.contact_email || '-'} readOnly className="ui-input" />
            </div>
            <div className="form-group">
              <label className="ui-label">
                <Mail size={16} />
                {t('fournisseurs.dialog.form.emailSecondary')}
              </label>
              <input type="text" value={fournisseur.contact_email_secondary || '-'} readOnly className="ui-input" />
            </div>
          </div>

          <div className="form-group">
            <label className="ui-label">
              <Phone size={16} />
              {t('fournisseurs.dialog.form.phone')}
            </label>
            <input type="text" value={fournisseur.contact_phone || '-'} readOnly className="ui-input" />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="ui-label">
                <CreditCard size={16} />
                {t('fournisseurs.dialog.form.iban')}
              </label>
              <input type="text" value={fournisseur.iban || '-'} readOnly className="ui-input" />
            </div>
            <div className="form-group">
              <label className="ui-label">
                <Landmark size={16} />
                {t('fournisseurs.dialog.form.bankAccountNumber')}
              </label>
              <input type="text" value={fournisseur.bank_account_number || '-'} readOnly className="ui-input" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="ui-label">
                <Landmark size={16} />
                {t('fournisseurs.dialog.form.bankBeneficiary')}
              </label>
              <input type="text" value={fournisseur.bank_beneficiary || '-'} readOnly className="ui-input" />
            </div>
            <div className="form-group">
              <label className="ui-label">
                <CircleDollarSign size={16} />
                {t('fournisseurs.dialog.form.devise')}
              </label>
              <input type="text" value={fournisseur.devise || 'EUR'} readOnly className="ui-input" />
            </div>
          </div>

          <div className="form-group">
            <label className="ui-label">
              <FileText size={16} />
              {t('fournisseurs.dialog.form.notes')}
            </label>
            <textarea value={fournisseur.notes || '-'} readOnly rows={2} className="ui-textarea" />
          </div>

          <div className="dialog-actions ui-dialog-actions">
            <button type="button" className="btn-secondary ui-btn-secondary" onClick={() => setIsHistoryOpen(true)}>
              <History size={18} /> {t('common.history')}
            </button>
            <button type="button" className="btn-secondary ui-btn-secondary" onClick={onClose}>
              {t('common.close')}
            </button>
          </div>
        </div>
      </div>

      <HistoryDialog
        isOpen={isHistoryOpen}
        onClose={() => setIsHistoryOpen(false)}
        title={t('history.title')}
        appLabel="suppliers"
        model="fournisseur"
        objectId={fournisseur?.id}
      />
    </div>
  );
};

export default ViewFournisseurDialog;
